import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '../button/button';
import { Label } from '../label/label';
import { Text } from '../text/text';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './success-story-card.scss';

const SuccessStoryCard = () => {
  const intl = useIntl();

  const handleClick = () => {
    window.location.href = intl.formatMessage({ id: 'translate.start.now.url' });
  };

  return (
    <div className="bd-success-story">
      <img
        className="bd-success-story__img"
        src="https://www.siteground.com/static/2024/en/img/web/sg_birthday/ctr_flower_girl.png"
        alt="Lady With Plants Image"
      />
      <div className="bd-success-story__text">
        <Label color="#FFF2AA">
          <Translate id="translate.success.card.special.offer" />
        </Label>
        <Title level="3" weight="bold" className="bd-success-story__text__title">
          <Translate id="translate.success.card.title" />
        </Title>
        <Text size="large" fontFamily="roboto" className="bd-success-story__text__bullets">
          <Translate id="translate.success.card.bullets" />
        </Text>
        <Button color="primary" onClick={handleClick}>
          <Translate id="translate.success.card.action.button" />
        </Button>
      </div>
    </div>
  );
};

export default SuccessStoryCard;
